import InstagramImage from './InstagramImage'

export default InstagramImage